import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import * as userRedux from '../redux/UserRedux';
import * as petRedux from '../../pets/redux/PetRedux';
import * as planRedux from '../../plans/redux/PlanRedux';
import * as orderRedux from '../../orders/redux/OrderRedux';
import * as taskRedux from '../../tasks/redux/TaskRedux';

interface RouteParams {
  id?: string;
  petId?: string;
  planId?: string;
  orderId?: string;
  taskId?: string;
}

export function usePathProps() {
  const dispatch = useDispatch();
  const { id, petId, planId, orderId, taskId } = useParams<RouteParams>();

  useEffect(() => {
    if (id?.length) {
      const numericId = parseInt(id, 10);
      dispatch(userRedux.actions.requestUser(numericId));
    } else {
      dispatch(userRedux.actions.resetUser());
    }

    if (petId?.length) {
      const numericPetId = parseInt(petId, 10);
      dispatch(petRedux.actions.requestPet(numericPetId));
    }

    if (planId?.length) {
      const numericPlanId = parseInt(planId, 10);
      dispatch(planRedux.actions.requestPlan(numericPlanId));
    }

    if (orderId?.length) {
      const numericOrderId = parseInt(orderId, 10);
      dispatch(orderRedux.actions.requestOrder(numericOrderId));
    }

    if (taskId?.length) {
      const numericTaskId = parseInt(taskId, 10);
      dispatch(taskRedux.actions.requestTask(numericTaskId));
    }
  }, [dispatch, id, petId, planId, orderId, taskId]);
}
